import { render } from "./SelectDelegate.vue?vue&type=template&id=42cb8d25&ts=true"
import script from "./SelectDelegate.vue?vue&type=script&lang=ts"
export * from "./SelectDelegate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__